<template>
  <div class="main">
    <div
      class="circle"
      :class="{
        circleActive: status === statusTypes.PAID,
        circleError: status === statusTypes.ERROR
      }"
    >
      <div
        class="circleInner"
        :class="{
          circleInnerActive: status === statusTypes.PAID,
          circleInnerError: status === statusTypes.ERROR
        }"
      />
    </div>
    <div class="timelineContent">
      <p class="timelineText">{{ value }}</p>
      <p class="timelineSubtitle">{{ subtitle }}</p>
      <v-chip :color="statusColor" dark small class="mt-3" label>
        {{ statusText }}
      </v-chip>
    </div>
  </div>
</template>

<script>
export const StatusTypes = Object.freeze({
  INIT: "init",
  PAID: "payed",
  ERROR: "error"
});

export default {
  name: "TimelineItem",
  props: ["value", "status", "subtitle"],
  computed: {
    statusColor() {
      switch (this.status) {
        case StatusTypes.PAID:
          return "#ffa903";
        case StatusTypes.ERROR:
          return "#ff5252";
        default:
          return "#A0A0AE";
      }
    },
    statusText() {
      switch (this.status) {
        case StatusTypes.PAID:
          return "Оплачен";
        case StatusTypes.ERROR:
          return "Произошла ошибка";
        default:
          return "В ожидании";
      }
    }
  },
  data() {
    return {
      statusTypes: StatusTypes
    };
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/style/vars";

.main {
  position: relative;
  width: 320px;
}

.timelineContent {
  position: absolute;
  top: 0;
  left: 60px;
}

.timelineText {
  margin: 0;
}

.timelineSubtitle {
  font-weight: 500;
  margin: 0;
}

.circle {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: rgba($grey, 0.5);
  transition: background-color 0.2s;
}

.circleInner {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: rgba($grey, 1);
  transition: background-color 0.2s;
}

.circleActive {
  background-color: rgba($activeColor, 0.5);
}

.circleInnerActive {
  background-color: rgba($activeColor, 1);
}

.circleError {
  background-color: rgba($danger, 0.5);
}

.circleInnerError {
  background-color: rgba($danger, 1);
}
</style>
